import { DISCOUNTS_MARGIN_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { DiscountsMarginChecklistRow } from './types';

export function buildDiscountsMarginQueueItem(row: DiscountsMarginChecklistRow): ApprovalQueueItem {
  return {
    categoryId: DISCOUNTS_MARGIN_CATEGORY.id,
    categoryLabel: DISCOUNTS_MARGIN_CATEGORY.label,
    description: `${row.title} requires approval.`,
    details: [{ label: 'Rule', value: row.rule }, { label: 'Source value', value: row.sourceValue }, ...row.details],
    id: row.id,
    title: row.title,
  };
}

export function getDiscountsMarginSearchText(row: DiscountsMarginChecklistRow) {
  return [row.title, row.rule, row.sourceValue, row.statusLabel].filter(Boolean).join(' ');
}
